import { Injectable } from '@angular/core';
import {
  AbstractGraphqlRequest,
  GraphqlRequestType,
  PaginationResult,
} from '@ckmk/angular';
import {
  PostCategoriesResult,
  PostCategoryFetchAllPayload,
} from '@app/src/app/modules/post/types/types';
import { TypedDocumentNode } from '@apollo/client';
import { PostCategoryModel } from '@app/src/app/modules/post/classes/category/model/post.category.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class PostCategoriesRequestQuery extends AbstractGraphqlRequest<
  PostCategoriesResult,
  { payload: PostCategoryFetchAllPayload }
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findAllPostCategories($payload: PostCategoryRequestPayloadInput) {
        findAllPostCategories(payload: $payload) {
          pagination {
            hasNext
            hasPrevious
            limit
            page
            total
            totalPage
          }
          result {
            id
            cover {
              id
              name
              extension
              directory
              directories
              frontUrls
              mimetype
            }
            slug
            title
            description
            active
            createdAt
            updatedAt
            deletedAt
            createdBy
            updatedBy
          }
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    let { pagination, result } = data.findAllPostCategories;

    if (pagination) {
      pagination = new PaginationResult(pagination);
    }

    result = result.map((grp: any) => new PostCategoryModel(grp));

    return { result, pagination };
  }
}
